import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { DynamicForm } from '../components/DynamicForm';

const API = process.env.REACT_APP_BACKEND_URL;

export default function ModuloAnteprima() {
  const { key } = useParams();
  const [params] = useSearchParams();
  const bozza = params.get('bozza') === '1';
  const [definition, setDefinition] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => {
    document.title = 'Anteprima modulo — Assietica';
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex,nofollow';
    document.head.appendChild(meta);
    return () => document.head.removeChild(meta);
  }, []);

  useEffect(() => {
    const load = async () => {
      try {
        if (bozza) {
          const res = await fetch(`${API}/api/forms/admin/all`, { credentials: 'include' });
          if (res.status === 401) { setErr('Per vedere la bozza devi prima accedere al pannello Admin.'); return; }
          const data = await res.json();
          const f = (data.forms || []).find((x) => x.key === key);
          if (!f) { setErr('Modulo non trovato.'); return; }
          setDefinition(f.draft);
        } else {
          const res = await fetch(`${API}/api/forms/${key}`);
          if (!res.ok) { setErr('Modulo non trovato.'); return; }
          setDefinition(await res.json());
        }
      } catch { setErr('Errore di connessione.'); }
    };
    load();
  }, [key, bozza]);

  return (
    <div className="min-h-screen bg-gray-50" data-testid="modulo-anteprima">
      <div className="text-center text-[11px] py-1.5 text-white font-semibold" style={{ backgroundColor: bozza ? '#E67E22' : '#1B2380' }}>
        {bozza ? 'ANTEPRIMA BOZZA — versione non ancora pubblicata, invio disattivato' : 'ANTEPRIMA MODULO PUBBLICATO — l\'invio funziona davvero'}
      </div>
      <div className="max-w-2xl mx-auto px-4 py-10">
        <Link to="/admin/avvisi" className="inline-flex items-center gap-1.5 text-sm text-[#1B2380] hover:underline mb-6" data-testid="modulo-anteprima-back">
          <ArrowLeft size={15} /> Torna al pannello Admin
        </Link>
        {err && <p data-testid="modulo-anteprima-error" className="text-sm text-red-600 bg-red-50 border border-red-200 rounded-lg px-4 py-3">{err}</p>}
        {definition && (
          <>
            <h1 className="text-3xl font-bold text-[#1B2380] mb-2">{definition.title}</h1>
            <p className="text-gray-500 mb-8">{definition.subtitle}</p>
            <div className="bg-white border border-gray-200 rounded-2xl p-6 sm:p-8 shadow-sm">
              <DynamicForm formKey={key} definition={definition} disabled={bozza} />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
